import React, {useEffect} from 'react';
import { withStyles, Typography, Grid, Button } from '@material-ui/core';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { Link } from 'react-router-dom'
import cn from 'classnames';
import ApplePayImage from 'assets/img/home/apple-pay.png';

// phase 3 icons
import calendarIcon from 'assets/img/home/calendar.svg';
import contractIcon from 'assets/img/home/contract.svg';
// import deliveryTruckIcon from 'assets/img/home/delivery-truck.svg';
// import dollyIcon from 'assets/img/home/dolly.svg';
import moneyIcon from 'assets/img/home/money.svg';
import phoneIcon from 'assets/img/home/phone.svg';
// import tabletsIcon from 'assets/img/home/tablets.svg';
import icon1 from 'assets/img/home/icon1.png';
import icon2 from 'assets/img/home/icon2.png';
import icon3 from 'assets/img/home/icon3.png';
//import banner images
import banner1 from 'assets/img/home/banner/banner1.png';
import AddIcon from '@material-ui/icons/Add';
import banner2 from 'assets/img/home/banner/banner2.png';
import banner3 from 'assets/img/home/banner/banner3.jpg';
import banner4 from 'assets/img/home/banner/banner4.png';
import banner5 from 'assets/img/home/banner/banner5.png';
import banner6 from 'assets/img/home/banner/banner6.jpg';
import banner7 from 'assets/img/home/banner/banner7.png';


import HomePageStyle from './HomePageStyle';
import Card1 from '../../components/Layout/Home/Card1/Card1';
import Card2 from '../../components/Layout/Home/Card2/Card2';
import StarRatings from "react-star-ratings";
import {MuiTheme} from "assets/theme";

import mainBg from 'assets/img/home/home-bg.jpg';
import mainBgWebp from 'assets/img/home/home-bg.webp';
import imgSectionBg from 'assets/img/home/homepage_img.jpg';
import imgSectionBgWebp from 'assets/img/home/homepage_img.webp';
import googleIcon from 'assets/img/shared/googleIcon.png';

const HomePage = (props) => {
  const { classes } = props;

  useEffect(() => {

  }, [])

  return (
    <>
      {/* Container 1 */}
      <Grid
        container
        direction="column"
        alignItems="center"
        justify="center"
        className={classes.container1}
      >
        <picture className={classes.mainBg}>
          <source srcSet={mainBgWebp} type={'image/webp'} className={classes.mainBg}/>
          <source srcSet={mainBg} type={'image/jpeg'} className={classes.mainBg}/>
          <img src={mainBg} alt={"Sendy Storage: Arizona's newest storage alternative"} className={classes.mainBg}/>
        </picture>

        <Grid item xs={11} align="center">
          <div className={classes.typingContainer}>
            <Typography variant={'h5'} className={classes.headerText1}>
              ON-DEMAND SELF STORAGE <br/>WITH <u>FREE</u> PICKUP
            </Typography>
            {/*fixes a bug where it'll otherwise go to the next line*/}
            <Typography variant="h5" className={classes.headerText6}>
              We Pickup. We Store. We Re-Deliver.
            </Typography><br/>

            <Typography variant={'h6'} className={classes.headerText6} style={{color: "white"}}>
              Located in Tucson, AZ and Austin, TX
            </Typography>
          </div>

          <Button color="primary" component={Link} to="/order/storage/" className={classes.getStartedButton}>
            Click Here to Get Started
          </Button>

          <div
            style={{
              width: '220px',
              padding: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '20px',
            }}
          >
            <img
              style={{
                width: '150px',
                height: 'auto',
              }}
              src={ApplePayImage}
            />
          </div>

        </Grid>
      </Grid>
      {/* -- Container 1 */}
      {/* Container 5 */}
      <Grid container className={classes.container5}>
        <Grid container direction="column"
              alignItems="center"
              justify="center"
        >
          <Grid item md={12} xs={12} align="center" >
            <Typography variant={'h2'} className={classes.headerText3} style={{marginBottom: '16px'}}>
              Experience effortless storage in the palm of your hand
            </Typography>

            <Typography variant="h4" style={{marginTop: '50px'}}>
              <strong>Here's How It Works</strong>
            </Typography>
          </Grid>
        </Grid>
        <Grid container >
          <Grid container item justify="center">
            <Grid item lg={3} xs={12}>
              <Card2
                image={icon1}
                altText="Closed Box"
                subtitle={'Select your belongings to store'}
                text='Simple per-item pricing with no hidden fees or having to wait for a quote.' />
            </Grid>
            <Grid item lg={3} xs={12}>
              <Card2
                image={icon2}
                altText="Delivery Truck"
                subtitle={'Schedule an exact appointment time, and we do the rest'}
                text='All you’ll do is pack, and we’ll pick up, transport, and safely store your belongings at one of our temperature and security controlled storage locations.' />
            </Grid>
            <Grid item lg={3} xs={12}>
              <Card2
                image={icon3}
                altText="Opened Box"
                subtitle={'Request your belongings back whenever you want'}
                text='Use our visual inventory system to select the exact belongings that you would like returned, and we will "Send" them right back at your convenience!' />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* -- Container 5 */}

      {/*banner container*/}
      <div className={classes.bannerContainer}>
        <img src={banner1} className={classes.bannerImage}/>
        <AddIcon className={classes.addIcon}/>
        <img src={banner2} className={cn(classes.bannerImage, classes.bannerImage2)}/>
        <img src={banner3} className={cn(classes.bannerImage, classes.bannerImage3)}/>
        <img src={banner4} className={classes.bannerImage}/>
        <img src={banner5} className={cn(classes.bannerImage, classes.bannerImage5)}/>
        <img src={banner6} className={classes.bannerImage}/>
        <img src={banner7} className={classes.bannerImage}/>
      </div>

      {/* Container 4 */}
      <Grid container className={classes.container4} alignItems="center" justify="center">
        <Grid item xs={12} align="center">
          <div className={classes.container4Inner}>
            <Typography variant={'h2'} className={classes.headerText3} style={{marginBottom: '16px'}}>
              STUDENT AND RESIDENTIAL STORAGE
            </Typography>

            <Typography variant="h5" style={{color: 'black', fontWeight: '500'}}>
              We offer a variety of services and storage solutions for students, residents, and businesses
            </Typography>

            <Button component={Link} to="/order/storage/" className={classes.getStartedButton2}>
              Click Here to Get Started
            </Button>

          </div>
        </Grid>
      </Grid>

      <Grid container className={classes.imgSection} direction={'column'} alignItems={'center'} justify={'flex-start'}>
        <picture className={classes.imgSectionBg}>
          <source srcSet={imgSectionBgWebp} type={'image/webp'} className={classes.imgSectionBg}/>
          <source srcSet={imgSectionBg} type={'image/jpeg'} className={classes.imgSectionBg}/>
          <img src={imgSectionBg} className={classes.imgSectionBg} alt={'Place an order in 2 minutes or less'}/>
        </picture>

        <Typography variant={'h4'} className={classes.imgSectionHeader}>
          PLACE AN ORDER IN 2 MINUTES OR LESS
        </Typography>
      </Grid>

      <Grid container className={classes.testimonialContainer} direction={'column'} wrap={'wrap'} alignItems={'center'} justify={'flex-start'} spacing={2}>
        <Grid item xs={12} align={'center'}>
          <StarRatings
            rating={5}
            starRatedColor={MuiTheme.palette.secondary.main}
            numberOfStars={5}
            starDimension={'50px'}
          />
          <Typography variant={'h3'} paragraph>
            <strong>MEET YOUR NEW FAVORITE STORAGE COMPANY</strong>
          </Typography>
          <Typography variant={'h5'} paragraph align={'center'} style={{maxWidth: '85%'}}>
            <strong>Check out our Google and App Store ratings to find out why we are rated 5 stars!</strong>
          </Typography>
        </Grid>
        <div className={classes.innerTestimonialContainer}>
          <div className={classes.testimonial}>
            <Typography variant={'h6'} className={classes.testimonialTitle}>
              By far the best at what they do!
            </Typography>
            <Typography variant={'body1'} className={classes.testimonialBody}>
              The folks at Sendy are truly awesome. They are by far the best at what they do!{' '}
              I will recommend them to friends and family as well as take advantage of their services{' '}
              in the future. Thanks, Sendy!
            </Typography>
            <Typography variant={'body2'} className={classes.testimonialFooter}>
              – Ian M
            </Typography>
            <div className={classes.googleReviewContainer}>
              <img src={googleIcon} className={classes.googleIcon}/>
              <Typography variant={'body2'} className={classes.testimonialFooter}>
                Posted on <br/>
                <span style={{color: "blue"}}>Google</span>
              </Typography>
            </div>
          </div>

          <div className={classes.testimonial}>
            <Typography variant={'h6'} className={classes.testimonialTitle}>
              11/10 Recommend!
            </Typography>
            <Typography variant={'body1'} className={classes.testimonialBody}>
              Amazing service! So much cheaper than a storage unit and they were able to change my{' '}
              pickup appt date and time so effortlessly. 11/10 recommend.
            </Typography>
            <Typography variant={'body2'} className={classes.testimonialFooter}>
              - Lydia
            </Typography>
            <div className={classes.googleReviewContainer}>
              <img src={googleIcon} className={classes.googleIcon}/>
              <Typography variant={'body2'} className={classes.testimonialFooter}>
                Posted on <br/>
                <span style={{color: "blue"}}>Google</span>
              </Typography>
            </div>
          </div>

          <div className={classes.testimonial}>
            <Typography variant={'h6'} className={classes.testimonialTitle}>
              All-inclusive service for such a great price!
            </Typography>
            <Typography variant={'body1'} className={classes.testimonialBody}>
              This is an all-inclusive service for such a great price! I was very nervous to move on my{' '}
              own however Sendy Storage made the process absolutely effortless. This is a great business{' '}
              and I highly recommend them for your storage needs! Thank you!
            </Typography>
            <Typography variant={'body2'} className={classes.testimonialFooter}>
              - Mackenzie R
            </Typography>
            <div className={classes.googleReviewContainer}>
              <img src={googleIcon} className={classes.googleIcon}/>
              <Typography variant={'body2'} className={classes.testimonialFooter}>
                Posted on <br/>
                <span style={{color: "blue"}}>Google</span>
              </Typography>
            </div>
          </div>
        </div>
      </Grid>
      {/* -- Container 4 */}
      {/* Container 2 */}
      <Grid container direction="column"
            alignItems="center"
            justify="center"
            className={classes.container2}>
        <Grid item xs={12} align="center">
          <Typography variant="h4" className={classes.headerText4}>
            Why Sendy Storage
          </Typography>
        </Grid>
      </Grid>
      {/* -- Container 2 */}
      {/* Container 3 */}
      <Grid container >
        <Grid container
              className={classes.container3}>
          <Grid item lg={3} md={6} xs={12}>
            <Card1
              svgLoader
              image={phoneIcon}
              altText="Home icon"
              header="De-clutter your home at the press of a button"
              body="On-Demand Self Storage service to your door, so you'll never visit a storage unit again! We Pickup, We Store, We Deliver with FREE pickup & $19.99 delivery."
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <Card1
              svgLoader
              image={calendarIcon}
              altText="Calendar icon"
              header="On your schedule"
              body="Easily schedule deliveries/pick-ups via our website or app, with no more guessing when drivers will arrive. Select a time that works best for you, and we'll make sure we're there." />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <Card1
              svgLoader
              image={contractIcon}
              altText="Receipt icon"
              header="Simple pricing & No contracts"
              body="Month-to-month billing with no hidden fees or commitments with just a 2 month minimum. What you see is what you pay - that is our Sendy Storage Guarantee." />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <Card1
              svgLoader
              image={moneyIcon}
              altText="Archive icon"
              header="Only pay for the space you need"
              body="Select exactly how many boxes/bins/items you have to store, and never pay for more space than you use." />
          </Grid>
        </Grid>
      </Grid>
      {/* -- Container 3 */}

      <Grid container className={classes.container4Alt} alignItems="center" justify="center">
        <Grid item xs={12} align="center">
          <div className={classes.container4Inner}>
            <Typography variant={'h2'} className={classes.headerText3} style={{marginBottom: '16px'}}>
              ENJOY FULL SERVICE STORAGE FROM THE COMFORT OF YOUR COUCH
            </Typography>
            <Typography variant="h5" style={{color: 'black', fontWeight: '500'}}>
              TAKE THE 'SELF' OUT OF SELF STORAGE AND LET US HANDLE THE REST
            </Typography>
            <Link to="/order/storage/">
              <Button className={classes.getStartedButton2}>
                Schedule a free appointment
              </Button>
            </Link>
          </div>
        </Grid>
      </Grid>
    </>
  )
};

export default withStyles(HomePageStyle)(HomePage);
